// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function HandWavingIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m27.525 12.5-2.25-3.898a3.5 3.5 0 0 0-5.913-.24L17.445 5.04a3.5 3.5 0 0 0-6.015-.079 3.5 3.5 0 0 0-5.375 4.347l.417.724a3.501 3.501 0 0 0-2.75 5.24l4.75 8.228a10.934 10.934 0 0 0 6.68 5.125A11 11 0 0 0 27.525 12.5Zm-.834 7.829A9 9 0 0 1 10.204 22.5l-4.75-8.227a1.5 1.5 0 1 1 2.598-1.5l2.75 4.762a1 1 0 1 0 1.732-1l-4.75-8.226a1.5 1.5 0 1 1 2.598-1.5l4.25 7.361a1 1 0 0 0 1.732-1l-3.25-5.625a1.5 1.5 0 0 1 2.597-1.5L20 13.473a6.01 6.01 0 0 0-1.375 7.624 1 1 0 0 0 1.732-1 4 4 0 0 1 1.464-5.463 1 1 0 0 0 .366-1.367l-1.25-2.165a1.5 1.5 0 0 1 2.598-1.5l2.25 3.898a8.937 8.937 0 0 1 .906 6.828ZM23.034 3.74a1 1 0 0 1 1.225-.707c1.988.534 3.625 1.764 4.607 3.466a1 1 0 0 1-1.732 1c-.715-1.24-1.92-2.14-3.393-2.534a1 1 0 0 1-.707-1.225Zm-12.92 25.884a1 1 0 0 1-1.405.166c-1.375-1.086-2.514-2.447-3.575-4.285a1 1 0 0 1 1.732-1c.93 1.61 1.909 2.79 3.081 3.715a1 1 0 0 1 .167 1.404Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
